import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { MovimientotesoreriaServiceProvider } from '../../providers/movimientotesoreria-service/movimientotesoreria-service'
import {DomSanitizer} from '@angular/platform-browser';

/**
 * Generated class for the RepoteEstadocuentaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-repote-estadocuenta',
  templateUrl: 'repote-estadocuenta.html',
})
export class RepoteEstadocuentaPage {

  auxreporte:{desde:String, hasta:String, idcuenta:0, urlpdf:any };
  cuentas=[];

  auxSemaforo:any =true;


  constructor(public navCtrl: NavController, public navParams: NavParams, public loadingCtrl: LoadingController,
  	public tesoreriaService: MovimientotesoreriaServiceProvider, public alertCtrl: AlertController,
    public sanitizer: DomSanitizer) {

  	var tzoffset = (new Date()).getTimezoneOffset() * 60000;

    let fechaDesde = new Date(Date.now() - tzoffset);
    fechaDesde.setMonth(fechaDesde.getMonth() - 1 )
    this.auxreporte={desde: fechaDesde.toISOString(), hasta: (new Date(Date.now() - tzoffset)).toISOString(), idcuenta:0, urlpdf:null };

  }

  ionViewDidLoad() {
  	this.tesoreriaService.getCuentas().subscribe(val => {
  		this.cuentas = val;
  	});
  }

  generar(){
    if(this.auxreporte.idcuenta==0)
      this.alertCtrl.create({
          title: 'Validacion de datos',
          subTitle: 'Seleccione una cuenta para generar el reporte.',
          buttons: ['OK']
        }).present();
    else{
      let loading = this.loadingCtrl.create({content: 'Cargando, espere por favor...' });
      loading.present();

      this.tesoreriaService.getReporteEstadoCuenta(1, this.auxreporte.desde ,this.auxreporte.hasta, this.auxreporte.idcuenta ).then(data=>{      
        let saldo: any=[] ;
        saldo = data;
        this.auxSemaforo= saldo.length > 0 ? false : true;

        this.urlpdf();

        loading.dismiss();
      })
      .catch(error=>{
        console.log(error);
        loading.dismiss();
      })
    }
  }

  abrirPDF()
  {
    window.open(this.tesoreriaService.serverServicios + "/estadocuenta.pdf", "_blank");
  }

  urlpdf() {
    this.auxreporte.urlpdf = this.auxSemaforo ? null: this.sanitizer.bypassSecurityTrustResourceUrl(this.tesoreriaService.serverServicios + "/estadocuenta.pdf");
    return this.auxreporte.urlpdf;
  }

}



// WEBPACK FOOTER //
// ./src/pages/repote-estadocuenta/repote-estadocuenta.ts